import {
  FixedScreenHeaderStack,
  Heading,
  SearchAndAddBar,
} from '~/common/components/defaultUIComponents';
import { DateInput } from '~/common/components/defaultUIComponents/DateInput';
import { useRoutineContext } from './RoutineContext';
import routes from '~/common/constants/routes.json';
import { useNavigate } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
export const RoutineHeaderStack: React.FC = () => {
  const navigate = useNavigate();
  const { setSearchTerm, startDate, setStartDate, endDate, setEndDate } =
    useRoutineContext();
  const handleCreateNewRoutine = () => {
    navigate(routes.CREATE_ROUTINE);
  };
  return (
    <FixedScreenHeaderStack>
      <Heading>routine.heading</Heading>
      <SearchAndAddBar
        onInputChange={setSearchTerm}
        onClick={handleCreateNewRoutine}
        inputPlaceholder="routines.searchProjects.input.placeholder"
        tooltipLabel="routines.addRoutine.tooltip.label"
      />

      <Flex align="end">
        <Box mr={5}>
          <DateInput
            label="routines.timeframe.start"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            labelAlign="left"
          />
        </Box>
        <Box mr={5}>
          <DateInput
            label="routines.timeframe.end"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            labelAlign="left"
          />
        </Box>
      </Flex>
    </FixedScreenHeaderStack>
  );
};
